export default __webpack_public_path__ + "../staticImages/sprite-appstore-2x.png";